<template>
<div class='footer'>
  <div class="footer-container">
 <Row type='flex' justify='center' align='middle'>
  <Col span='12'>
    <div class='img-list'>
      <div class='yhy-zzh'>
        <div>
          <img src="@/assets/xsgzh.png" width="90px" height="auto"/>
        </div>
        <div>香山公园公众号</div>
      </div>
      <div class='yhy-zzh'>
        <div>
          <img src="@/assets/xswb.png" width="90px" height="auto"/>
        </div>
        <div>香山公园官方微博</div>
      </div>
      <div class='yhy-zzh'>
        <div>
          <img src="@/assets/xswcd.png" width="90px" height="auto"/>
        </div>
         <div>香山文创旗舰店</div>
      </div>
    </div>
  </Col>
    <Col span='12'>
      <div class="footer-font">友情链接：香山公园官方网站</div>
      <div class="footer-font">咨询电话：62591222 62591155 62599886 价格监督电话：12345 12315</div>
      <div class="footer-font">香山版权所有 京ICP备18006609号</div>
    </Col>
  </Row>
  </div>
</div>
</template>

<script>
export default {
}
</script>

<style scoped lang="less">
.yhy-zzh{
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-left: 20px;
}
.footer{
  width:100% ;
  background-color: @footer;
  padding: 20px;
  font-weight: 500;
  color: @font-white;
}
.footer-container{
  width:1200px;
  margin: 0 auto;
}
.img-list{
  display: flex;
  margin-left:20px;
}
.footer-font{
  line-height: 30px;
}
</style>
